<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

	  		<!------------ 经营流水 ------------->
	  		<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		        <el-form-item style="width:12%">
		            <el-select v-model="flowquery.flowtype" filterable remote reserve-keyword @change="changedate">
		          		<el-option v-for="(item,index) in flowtype" :key="index" :label="item.name" :value="item.id"></el-option>
		        	</el-select> 
		        </el-form-item>
		        
		        <!-------按日期查找-------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==3">
		            <el-date-picker v-model="flowquery.start" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==3">
		            <el-date-picker v-model="flowquery.end" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        
		        <!--------按月份查找------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==2">
		            <el-date-picker v-model="flowquery.start" type="month" placeholder="开始月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==2">
		            <el-date-picker v-model="flowquery.end" type="month" placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        
		        <!--------按年份查找------------->
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==1">
		            <el-date-picker v-model="flowquery.start" type="year" placeholder="开始年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>
		        <el-form-item style="width:15%" v-if="flowquery.flowtype==1">
		            <el-date-picker v-model="flowquery.end" type="year" placeholder="结束年份" format="yyyy" value-format="yyyy-MM-dd" style="width:100%" @change="flowselect=true"></el-date-picker>
		        </el-form-item>		        
		  		<el-form-item>
		  			<el-button type="primary" icon="el-icon-search" @click="getflowdata">搜索</el-button>
		  			<el-button type="primary" @click="outdatas" :loading="outputLoading">导出</el-button>
		  		</el-form-item>
		  		<el-form-item v-if="flowquery.flowtype==3">
		  			<el-tag type="danger">注：按日期搜索经营流水时，最多不能超过90天的数据</el-tag>
		  		</el-form-item>
		  	</el-form>
		  	
		  	<div class="backborder2" style="margin-top:10px">
			  	<el-table :data="flowdata" style="width: 100%" v-loading="flowLoading">
		        	<el-table-column label="序号" prop="sort" width="80" align="center"></el-table-column>
		        	<el-table-column label="时间维度" prop="time"></el-table-column>
		        	<el-table-column label="销售金额" prop="selltotals" width="100" align="center"></el-table-column>
		        	<el-table-column label="销售笔数" prop="sellnums" width="100" align="center"></el-table-column>
		        	<el-table-column label="退货金额" prop="refundtotals" width="100" align="center"></el-table-column>
		        	<el-table-column label="退货笔数" prop="refundnums" width="100" align="center"></el-table-column>
		        	<el-table-column label="销售毛利" prop="sellincome" width="100" align="center"></el-table-column>
		        	<el-table-column label="毛利率" prop="incomepercent" width="100" align="center"></el-table-column>
		        	<el-table-column label="首客数" prop="firstnums" width="100" align="center"></el-table-column>
		        	<el-table-column label="首客销售金额" prop="firstsells" width="110" align="center"></el-table-column>
		        	<el-table-column label="回购客户数" prop="againnums" width="100" align="center"></el-table-column>
		        	<el-table-column label="回购客户销售金额" prop="againsells" width="140" align="center"></el-table-column>
	      		</el-table>
	      		<div class="block">
	            <!--分页begin-->
	            <el-pagination
		            @size-change="flowPageSizeChange"
		            @current-change="flowPageCurrentChange"
		            :current-page="flowquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="flowquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="flow_rows">
	            </el-pagination>
	            <!--分页end-->
	      		</div>
      		</div>		  	
	  	
	  	<!---------------------------- 导出信息确认 ---------------------------->
	      <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="90%" top="5vh">
	      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	  <div id="outputorder">
		      	  <el-table :data="flowexportdata" border v-loading="exportLoading">
		      	  	  <el-table-column label="序号" prop="sort" width="80" align="center"></el-table-column>
		        	  <el-table-column label="时间维度" prop="time" width="100"></el-table-column>
		        	  <el-table-column label="销售金额" prop="selltotals" width="100" align="center"></el-table-column>
		        	  <el-table-column label="销售笔数" prop="sellnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="退货金额" prop="refundtotals" width="100" align="center"></el-table-column>
		        	  <el-table-column label="退货笔数" prop="refundnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="销售毛利" prop="sellincome" width="100" align="center"></el-table-column>
		        	  <el-table-column label="毛利率" prop="incomepercent" width="100" align="center"></el-table-column>
		        	  <el-table-column label="首客数" prop="firstnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="首客销售金额" prop="firstsells" width="100" align="center"></el-table-column>
		        	  <el-table-column label="回购客户数" prop="againnums" width="100" align="center"></el-table-column>
		        	  <el-table-column label="回购客户销售金额" prop="againsells" width="100" align="center"></el-table-column>	          	  	          	  
		      	  </el-table>
	      	  </div>
	      	  <div slot="footer" class="dialog-footer">
		          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		      </div>	                
	      </el-dialog> 
    	    	
    </div>
    </transition>
</template>

<script>

export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Datastat/index",
	        transitionshow:true,
	        actionauth:[],
	        query: {
	        	act:'managesale',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        saleLoading:false,
	        saledatas:[],
	        getquery: {
	        	act:'manageincome',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        getLoading:false,
	        incomedata:[],
	        emptyquery: {
	        	act:'emptyaccount',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        emptyLoading:false,
	        emptyaccounts:[],
	        noemptyquery: {
	        	act:'noemptyaccount',
	      	    token:this.$cookies.get('token'),
	      	    start:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	      	    end:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
	        },
	        noemptyLoading:false,
	        noemptyaccounts:[],
	        flowquery: {
	        	act:'getflowdatas',
	      	    token:this.$cookies.get('token'),
	      	    start:'',
	      	    end:'',
	      	    p:1,
	      	    rollpage:10,
	      	    flowtype:3,
	      	    type:1, //是否分商信息分页 1、是（用于搜索）2、否（用于数据导出）
	        },
	        flowDialog:false,
	        flowLoading:false,
	        flowtype:[{id:1,name:'按年份'},{id:2,name:'按月份'},{id:3,name:'按日期'}],
	        flowdata:[],
	        flow_rows:0,
	        flowselect:false,
	        outputDialog:false,
	        outputLoading:false,
	        flowexportquery: {
	        	act:'getflowexportdatas',
	      	    token:this.$cookies.get('token'),
	      	    start:'',
	      	    end:'',
	      	    flowtype:3,
	      	    type:2, //是否分商信息分页 1、是（用于搜索）2、否（用于数据导出）
				isexport:1,
	        },
	        flowexportdata:[],
	    }
    },
    
    mounted(){
  		this.getactionauth(); //获取权限设置
  		this.getsalesdata(); //获取销售情况信息
  		this.getincome(); //收款情况
  		this.getemptyaccount(); //获取欠货两清信息
  		this.nogetemptyaccount(); //获取欠货未清信息
    },
    
    methods:{   
     
	    /** 获取操作功能权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },
	    
	    checkflow() {
     		this.flowquery.type=1;
     		this.flowquery.start='';
	    	this.flowquery.end='';
	    	this.flowselect=true;
     		this.flowdata=[];
	    },
	    
	    
	    /** 获取今日、昨日、本月、本年数据 **/
	    getsalestypedata(type) {
	    	if(type==1) { //今日
	    		var nowday=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate();  		   		
	    		this.query.start=nowday;
	    		this.query.end=nowday;
	    		
	    	}else if(type==2) { //昨日
	    		var myday=new Date(new Date() - 1000*60*60*24);
	    		var yesterday=myday.getFullYear().toString()+'-'+(myday.getMonth()+1)+'-'+myday.getDate();
	    		this.query.start=yesterday;
	    		this.query.end=yesterday;
	    	
	    	}else if(type==3) { //本月
	    		var nowDate = new Date();
				var cloneNowDate = new Date();
				var fullYear = nowDate.getFullYear();
				var month = nowDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月
				var endOfMonth = new Date(fullYear, month, 0).getDate(); // 获取本月最后一天
				var starDate = this.getFullDate(cloneNowDate.setDate(1));//当月第一天
				var endDate = this.getFullDate(cloneNowDate.setDate(endOfMonth));//当月最后一天
				this.query.start=starDate;
	    		this.query.end=endDate;
	    	
	    	}else if(type==4) { //本年
	    		var nowDate = new Date();
	    		var start=nowDate.getFullYear()+"-"+"01"+"-"+"01";
	    		var end=nowDate.getFullYear()+"-"+"12"+"-"+"31";
	    		this.query.start=start;
	    		this.query.end=end;
	    	}
	    
	    	this.getsalesdata(); //获取销售情况信息
	    	this.getincome(); //获取收款情况信息
	    	this.getemptyaccount(); //获取钱货两清信息
	    	this.nogetemptyaccount(); //获取欠货未清信息
	    },
	    
	    getFullDate(targetDate) {
	        var D, y, m, d;
	        if (targetDate) {
	            D = new Date(targetDate);
	            y = D.getFullYear();
	            m = D.getMonth() + 1;
	            d = D.getDate();
	        } else {
	            y = fullYear;
	            m = month;
	            d = date;
	        }
	        m = m > 9 ? m : '0' + m;
	        d = d > 9 ? d : '0' + d;
	        return y + '-' + m + '-' + d;
	    },
	    
	    search() {
	    	this.getsalesdata(); //获取销售情况信息
	  		this.getincome(); //收款情况
	  		this.getemptyaccount(); //获取钱货两清信息
	  		this.nogetemptyaccount(); //获取钱货未清信息
	    },
	    
	    /** 获取销售情况信息 **/
	    getsalesdata() {
	    	this.saleLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.saleLoading=false;
		        }else{
		            this.saledatas = JSON.parse(Base64.decode(res.data.Data));
		            this.saleLoading=false;
		        }
	        }).catch((res) => {
	            this.saleLoading=false;
	        });	    
	    },
	    
	    /** 获取收款情况信息 **/
     	getincome() {
     		this.getquery.start=this.query.start;
     		this.getquery.end=this.query.end;
     		
     		this.getLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.getquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.getLoading=false;
		        }else{
		            this.incomedata = JSON.parse(Base64.decode(res.data.Data));
		            this.getLoading=false;
		        }
	        }).catch((res) => {
	            this.getLoading=false;
	        });	
     	},
     	
     	/** 获取钱货两清数据 **/
     	getemptyaccount() {
     		this.emptyquery.start=this.query.start;
     		this.emptyquery.end=this.query.end;
     		
     		this.emptyLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.emptyquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.emptyLoading=false;
		        }else{
		            this.emptyaccounts = JSON.parse(Base64.decode(res.data.Data));
		            this.emptyLoading=false;
		        }
	        }).catch((res) => {
	            this.emptyLoading=false;
	        });	
     	},
     	
     	/** 获取钱货未清信息 **/
     	nogetemptyaccount() {
     		this.noemptyquery.start=this.query.start;
     		this.noemptyquery.end=this.query.end;
     		
     		this.noemptyLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.noemptyquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.noemptyLoading=false;
		        }else{
		            this.noemptyaccounts = JSON.parse(Base64.decode(res.data.Data));
		            this.noemptyLoading=false;
		        }
	        }).catch((res) => {
	            this.noemptyLoading=false;
	        });	
     	},
     	
     	/** 查看经营流水 **/
     	checkflow() {
     		this.$emit('listenchild',{name:'查看经营流水',url:'Managestatefund'});
     		return false;
     	
     		this.flowDialog=true;
     		this.flowquery.type=1;
     		this.flowquery.start='';
	    	this.flowquery.end='';
	    	this.flowselect=true;
     		this.flowdata=[];
     	},
     	
     	/** 获取经营流水数据 **/
     	getflowdata() {
     		if(this.flowselect==true) {
     			this.flowquery.p=1;
	    		this.flowquery.rollpage=10;
     		}
     	
     		this.flowLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.flowquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.flowLoading=false;
		        }else{
		            this.flowdata = JSON.parse(Base64.decode(res.data.Data));
		            this.flow_rows=parseInt(res.data.count);
		            this.flowLoading=false;
		            if(this.flowselect==true) this.flowselect=false;
		        }
	        }).catch((res) => {
	            this.flowLoading=false;
	        });	
     	},
     	
     	flowPageSizeChange(val) {
        	this.flowquery.rollpage = val;
        	this.getflowdata();
	    },
	    flowPageCurrentChange(val) {
	        this.flowquery.p = val;
	        this.getflowdata();
	    },
	    
	    changedate() {
			this.flowquery.start='';
	    	this.flowquery.end='';
	    	this.flowselect=true;
	    },
	    
	    //导出经营流水
	    outdatas() {
	    	this.outputLoading=true;
	    	this.flowexportquery.start=this.flowquery.start;
	    	this.flowexportquery.end=this.flowquery.end;
	    	this.flowexportquery.flowtype=this.flowquery.flowtype;	  
	    	this.outputDialog=true;  	
	    	this.getflowexportdata();
		    this.outputLoading=false;
	    },
	    
	    /** 获取经营流水数据 **/
     	getflowexportdata() {
     		this.exportLoading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.flowexportquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.exportLoading=false;
		        }else{
		            this.flowexportdata = JSON.parse(Base64.decode(res.data.Data));
		            this.exportLoading=false;
		        }
	        }).catch((res) => {
	            this.exportLoading=false;
	        });	
     	},
	    
	    
	    /** 确认导出订单信息 **/
	    sureoutput() {
			require.ensure([], () => {			
				var { export_json_to_excel } = require('../../vendor/Export2Excel');
				var tHeader = ['序号','时间维度','销售金额','销售笔数','退货金额','退货笔数','销售毛利','毛利率','首客数','首客销售金额','回购客户数','回购客户销售金额'];
				var filterVal = ['sort','time','selltotals','sellnums','refundtotals','refundnums','sellincome','incomepercent','firstnums','firstsells','againnums','againsells'];
					
				var list = this.flowexportdata;
				var data = this.formatJson(filterVal, list);
				export_json_to_excel(tHeader, data, '经营流水');
				this.outputDialog=false;
			})
	    },
	    
	    //导出表格数据
		formatJson(filterVal, jsonData) {
	　　　　return jsonData.map(v => filterVal.map(j => v[j]));
	　　},
	    
     
    }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.menubutton:focus, .menubutton:hover {color:#fff;border-color:#409EFF;background-color:#409EFF}
.salesmain {padding:2% 2% 2% 2%;background:#fff;border-radius:5px;float:left;width:96%;}
.bordertitle {float:left;width:100%;}
.bordertitle img {float:left;width:4%;}
.bordertitle span {float:left;font-size:16px;margin-left:1%;padding:0.6% 0 0.6% 0;color:#606266;}
.bordermain {float:left;width:100%;}
.bordermain .single {float:left;width:16%;text-align:center;}
.bordermain .single span {float:left;width:100%;font-size:20px;text-align:center;font-weight:bold;color:#F56C6C;margin-top:12%}
.bordermain .single span i {font-size:14px;font-style:normal;}
.bordermain .single p {float:left;width:100%;text-align:center;font-size:14px;color:#909399;margin-top:3%}
.bordermain .double {float:left;width:20%;padding:0 1% 0 1%;text-align:center;background:#E4E7ED}
.bordermain .double table {float:left;width:100%;padding:10% 0 8% 0}
.bordermain .double table td {font-size:14px;color:#909399;}
.firstcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#67C23A;background:#DCDFE6}
.secondcustomer {font-style:normal;padding:2px 5px 2px 5px;border-radius:15px;color:#E6A23C;background:#DCDFE6}
.double p {float:left;width:100%;margin-top:10%;text-align:center;font-size:14px;color:#909399}
.double p i {font-style:normal;color:#606266}
.percent {float:left;margin-top:3%;border-radius:15px;width:70%;height:10px;margin-bottom:8%;background:#C0C4CC}
.percent h {float:left;height:100%;background:#E6A23C;border-radius:15px}
.double em {font-style:normal;color:#606266;font-size:14px;float:left;line-height:22px;margin-left:5%}

.moneymain {padding:2% 2% 2% 2%;background:#fff;border-radius:5px;float:left;width:45.5%;}
.moneymain .bordertitle {float:left;width:100%;}
.moneymain .bordertitle img {float:left;width:8%;}
.moneymain .bordertitle span {float:left;font-size:16px;margin-left:2%;padding:1% 0 1% 0;color:#606266;}
.bordermain1 {float:left;width:100%;background:#E4E7ED;margin:3% 0 3% 0}
.bordermain1 .left {float:left;width:20%;height:100px;}
.bordermain1 .left span {float:left;width:100%;text-align:center;font-size:20px;color:#fff;margin-top:20px}
.bordermain1 .left span i {font-style:normal;font-size:14px;}
.bordermain1 .right {float:left;margin:20px 0 0 3%;width:77%}
.bordermain1 .right span {float:left;width:100%;margin-top:10px;font-size:14px;line-height:18px;color:#909399}
.bordermain1 .right span i {color:#606266;font-style:normal}
</style>


// WEBPACK FOOTER //
// src/components/stat/Managestatefund.vue